// 功能開關
// App 推播 + 通知小鈴鐺 + 通知中心。
// 由各環境的 .env.* 中的 VUE_APP_ENABLE_NOTIFICATIONS 決定，未設定時視為關閉：
//   .env.development / .env.preview → true （本機與 ittest 測試站開啟）
//   .env.production                 → false（正式站尚未開放）
// 要正式開啟時，把 .env.production 的值改成 true 即可全部開回（不需再動各元件）。
export const ENABLE_NOTIFICATIONS = process.env.VUE_APP_ENABLE_NOTIFICATIONS === "true";

// 會員中心「帳號安全」的「刪除帳號」入口（2026-10-28 使用者要求先藏起來，先看 Google Play 上架的結果）。
// 只藏入口：/account-deletion 網址與後端照常運作 —— Play Console 的資料安全性表單一定要填一個刪除網址。
// 注意 Google Play 規定 App 內也要找得到刪除帳號；審核因此被退件時，改成 true 即可打開。
// 打開時隱私權政策第七、九條的申請方式要一起改回「會員中心 → 帳號安全管理 → 刪除帳號」。
export const SHOW_ACCOUNT_DELETION_ENTRY = false;
